import {
  Add as AddIcon,
  ContentCopy as ContentCopyIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Filter as FilterIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import ObrigacoesPadraoModal from "../components/ObrigacoesPadraoModal";
import { useAuth } from "../context/AuthContext";
import {
  adminService,
  clienteService,
  recorrenciaService,
  setorService,
  tipoObrigacaoService,
} from "../services/api";

const Impostos = () => {
  // ✅ CONFIGURAÇÃO DOS TAMANHOS DOS FILTROS - CSS PURO RESPONSIVO!
  // Valores de 0 a 100 (porcentagem da largura no desktop)
  // Mobile: sempre 100% (empilhados)
  // 💡 TESTE: Mude os valores e veja a diferença imediatamente!
  const TAMANHOS_FILTROS = {
    busca: 40, // 40% da largura no desktop
    simples_nacional: 12, // 12% da largura no desktop
    lucro_presumido: 12, // 12% da largura no desktop
    lucro_real: 12, // 12% da largura no desktop
    escritorio: 24, // 24% da largura no desktop
  };

  const { user } = useAuth();

  const [tipos, setTipos] = useState([]);
  const [escritorios, setEscritorios] = useState([]);
  const [setores, setSetores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [excluindo, setExcluindo] = useState(false);

  // Estado para controlar visibilidade dos filtros
  const [mostrarFiltros, setMostrarFiltros] = useState(false);

  const [filtros, setFiltros] = useState({
    busca: "",
    simples_nacional: "",
    lucro_presumido: "",
    lucro_real: "",
    escritorio_id_filter: "",
  });
  const [paginacao, setPaginacao] = useState({
    page: 0,
    limit: 10,
    total: 0,
  });

  // Estados para modal de tipo de obrigação
  const [modalAberto, setModalAberto] = useState(false);
  const [tipoEditando, setTipoEditando] = useState(null);
  const [dadosTipo, setDadosTipo] = useState({
    descricao: "",
    dia_recorrente: "",
    mes_recorrente: "",
    dia_recorrente_real: "",
    mes_recorrente_real: "",
    simples_nacional: false,
    lucro_presumido: false,
    lucro_real: false,
    setor_id: "",
  });

  // Estados para notificações
  const [snackbar, setSnackbar] = useState({
    aberto: false,
    mensagem: "",
    tipo: "success",
  });

  // Estados para confirmação de exclusão
  const [confirmacaoExclusao, setConfirmacaoExclusao] = useState({
    aberto: false,
    tipoId: null,
    tipoDescricao: "",
  });

  // Estados para modal de seleção de clientes após criar tipo de obrigação
  const [modalSelecaoClientesAberto, setModalSelecaoClientesAberto] =
    useState(false);
  const [tipoObrigacaoCriado, setTipoObrigacaoCriado] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [clientesSelecionados, setClientesSelecionados] = useState([]);
  const [todosSelecionados, setTodosSelecionados] = useState(false);
  const [criandoRecorrencias, setCriandoRecorrencias] = useState(false);
  const [resultadoCriacao, setResultadoCriacao] = useState(null);

  // Estados para modal de obrigações padrão
  const [modalObrigacoesPadraoAberto, setModalObrigacoesPadraoAberto] =
    useState(false);
  const [tiposPadrao, setTiposPadrao] = useState([]);
  const [carregandoTiposPadrao, setCarregandoTiposPadrao] = useState(false);

  const carregarEscritorios = useCallback(async () => {
    try {
      const response = await adminService.getEscritorios();
      setEscritorios(Array.isArray(response) ? response : []);
    } catch (error) {
      console.error("Erro ao carregar escritórios:", error);
    }
  }, []);

  const carregarSetores = useCallback(async () => {
    try {
      const response = await setorService.getAll();
      setSetores(response.setores || []);
    } catch (error) {
      console.error("Erro ao carregar setores:", error);
    }
  }, []);

  const carregarClientes = useCallback(async () => {
    try {
      const response = await clienteService.getAll({
        limit: 1000,
        ativo: true,
      });
      setClientes(response.clientes || []);
    } catch (error) {
      console.error("Erro ao carregar clientes:", error);
    }
  }, []);

  const carregarTipos = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        page: paginacao.page + 1,
        limit: paginacao.limit,
      };

      if (filtros.busca) params.busca = filtros.busca;
      if (filtros.simples_nacional !== "")
        params.simples_nacional = filtros.simples_nacional === "true";
      if (filtros.lucro_presumido !== "")
        params.lucro_presumido = filtros.lucro_presumido === "true";
      if (filtros.lucro_real !== "")
        params.lucro_real = filtros.lucro_real === "true";
      if (filtros.escritorio_id_filter)
        params.escritorio_id_filter = filtros.escritorio_id_filter;

      const response = await tipoObrigacaoService.getAll(params);
      setTipos(response.tipos_obrigacoes || []);
      setPaginacao((prev) => ({
        ...prev,
        total: response.pagination?.total || 0,
      }));
    } catch (error) {
      mostrarSnackbar(
        "Erro ao carregar tipos de obrigação: " + error.message,
        "error",
      );
    } finally {
      setLoading(false);
    }
  }, [paginacao.page, paginacao.limit, filtros]);

  useEffect(() => {
    carregarTipos();
  }, [carregarTipos]);

  useEffect(() => {
    if (user?.is_super_admin) {
      carregarEscritorios();
    }
  }, [carregarEscritorios, user]);

  useEffect(() => {
    carregarSetores();
  }, [carregarSetores]);

  useEffect(() => {
    carregarClientes();
  }, [carregarClientes]);

  const mostrarSnackbar = (mensagem, tipo = "success") => {
    setSnackbar({
      aberto: true,
      mensagem,
      tipo,
    });
  };

  const handleFiltroChange = (campo, valor) => {
    setFiltros((prev) => ({
      ...prev,
      [campo]: valor,
    }));
    setPaginacao((prev) => ({ ...prev, page: 0 }));
  };

  const abrirModalTipo = (tipo = null) => {
    if (tipo) {
      setTipoEditando(tipo);
      setDadosTipo({
        descricao: tipo.descricao || "",
        dia_recorrente: tipo.dia_recorrente || "",
        mes_recorrente: tipo.mes_recorrente || "",
        dia_recorrente_real: tipo.dia_recorrente_real || "",
        mes_recorrente_real: tipo.mes_recorrente_real || "",
        simples_nacional: tipo.simples_nacional || false,
        lucro_presumido: tipo.lucro_presumido || false,
        lucro_real: tipo.lucro_real || false,
        setor_id: tipo.setor?.id || "",
      });
    } else {
      setTipoEditando(null);
      setDadosTipo({
        descricao: "",
        dia_recorrente: "",
        mes_recorrente: "",
        dia_recorrente_real: "",
        mes_recorrente_real: "",
        simples_nacional: false,
        lucro_presumido: false,
        lucro_real: false,
        setor_id: "",
      });
    }
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setTipoEditando(null);
  };

  const fecharModalSelecaoClientes = () => {
    setModalSelecaoClientesAberto(false);
    setTipoObrigacaoCriado(null);
    setClientesSelecionados([]);
    setTodosSelecionados(false);
    setResultadoCriacao(null);
  };

  const toggleClienteSelecao = (clienteId) => {
    setClientesSelecionados((prev) => {
      if (prev.includes(clienteId)) {
        const novaSelecao = prev.filter((id) => id !== clienteId);
        // Se desmarcou um cliente, desmarcar "todos selecionados"
        if (prev.length === clientes.length) {
          setTodosSelecionados(false);
        }
        return novaSelecao;
      } else {
        const novaSelecao = [...prev, clienteId];
        // Se selecionou todos os clientes disponíveis, marcar "todos selecionados"
        if (novaSelecao.length === clientes.length) {
          setTodosSelecionados(true);
        }
        return novaSelecao;
      }
    });
  };

  const toggleTodosClientesSelecao = () => {
    if (todosSelecionados) {
      setClientesSelecionados([]);
      setTodosSelecionados(false);
    } else {
      setClientesSelecionados(clientes.map((c) => c.id));
      setTodosSelecionados(true);
    }
  };

  const criarRecorrenciasLote = async () => {
    if (
      criandoRecorrencias ||
      clientesSelecionados.length === 0 ||
      !tipoObrigacaoCriado
    ) {
      return;
    }

    try {
      setCriandoRecorrencias(true);
      setResultadoCriacao(null);

      const resultados = [];
      let totalRecorrenciasCriadas = 0;
      let totalObrigacoesCriadas = 0;

      for (const clienteId of clientesSelecionados) {
        try {
          const cliente = clientes.find((c) => c.id === clienteId);
          if (!cliente) continue;

          // Verificar se o cliente é compatível com o tipo de obrigação
          const isCompatible = verificarCompatibilidadeCliente(
            cliente,
            tipoObrigacaoCriado,
          );

          // Criar recorrência para este cliente
          const dadosRecorrencia = {
            cliente_id: clienteId,
            tipo_obrigacao_id: tipoObrigacaoCriado.id,
            setor_id: tipoObrigacaoCriado.setor_id || null,
            dia_recorrente: tipoObrigacaoCriado.dia_recorrente,
            mes_recorrente: tipoObrigacaoCriado.mes_recorrente || null,
          };

          const response = await recorrenciaService.create(dadosRecorrencia);

          resultados.push({
            cliente_id: clienteId,
            nome: cliente.nome,
            sucesso: true,
            recorrencia: response,
            obrigacao: response.primeira_obrigacao,
            compativel: isCompatible,
          });

          totalRecorrenciasCriadas++;
          if (response.primeira_obrigacao) {
            totalObrigacoesCriadas++;
          }
        } catch (error) {
          const cliente = clientes.find((c) => c.id === clienteId);
          resultados.push({
            cliente_id: clienteId,
            nome: cliente?.nome || "Cliente não encontrado",
            sucesso: false,
            erro: error.message || "Erro ao criar recorrência",
          });
        }
      }

      setResultadoCriacao({
        total_recorrencias_criadas: totalRecorrenciasCriadas,
        total_obrigacoes_criadas: totalObrigacoesCriadas,
        clientes_processados: clientesSelecionados.length,
        detalhes_por_cliente: resultados,
      });
    } catch (error) {
      mostrarSnackbar("Erro ao criar recorrências: " + error.message, "error");
    } finally {
      setCriandoRecorrencias(false);
    }
  };

  const verificarCompatibilidadeCliente = (cliente, tipoObrigacao) => {
    if (!cliente.regime_tributario || !tipoObrigacao) return false;

    const regime = cliente.regime_tributario;

    switch (regime) {
      case "simples_nacional":
        return tipoObrigacao.simples_nacional;
      case "lucro_presumido":
        return tipoObrigacao.lucro_presumido;
      case "lucro_real":
        return tipoObrigacao.lucro_real;
      default:
        return false;
    }
  };

  const handleInputChange = (campo, valor) => {
    setDadosTipo((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const salvarTipo = async () => {
    if (salvando) return; // Evita cliques duplos

    try {
      setSalvando(true);

      if (!dadosTipo.descricao.trim()) {
        mostrarSnackbar("Descrição é obrigatória", "error");
        return;
      }

      if (!dadosTipo.dia_recorrente) {
        mostrarSnackbar("Dia recorrente é obrigatório", "error");
        return;
      }

      // Validar dia_recorrente (1-31)
      if (dadosTipo.dia_recorrente < 1 || dadosTipo.dia_recorrente > 31) {
        mostrarSnackbar("Dia recorrente deve estar entre 1 e 31", "error");
        return;
      }

      // Validar mes_recorrente se fornecido (1-12)
      if (
        dadosTipo.mes_recorrente &&
        (dadosTipo.mes_recorrente < 1 || dadosTipo.mes_recorrente > 12)
      ) {
        mostrarSnackbar("Mês recorrente deve estar entre 1 e 12", "error");
        return;
      }

      const dados = {
        descricao: dadosTipo.descricao.trim(),
        dia_recorrente: parseInt(dadosTipo.dia_recorrente),
        mes_recorrente: dadosTipo.mes_recorrente
          ? parseInt(dadosTipo.mes_recorrente)
          : null,
        dia_recorrente_real: dadosTipo.dia_recorrente_real
          ? parseInt(dadosTipo.dia_recorrente_real)
          : null,
        mes_recorrente_real: dadosTipo.mes_recorrente_real
          ? parseInt(dadosTipo.mes_recorrente_real)
          : null,
        simples_nacional: dadosTipo.simples_nacional,
        lucro_presumido: dadosTipo.lucro_presumido,
        lucro_real: dadosTipo.lucro_real,
        setor_id: dadosTipo.setor_id || null,
      };

      if (tipoEditando) {
        const tipoAtualizado = await tipoObrigacaoService.update(
          tipoEditando.id,
          dados,
        );
        mostrarSnackbar("Tipo de obrigação atualizado com sucesso!");

        // Fechar modal atual e abrir modal de seleção de clientes
        fecharModal();
        carregarTipos();

        // Se existem clientes ativos, abrir modal de seleção
        if (clientes.length > 0) {
          setTipoObrigacaoCriado(tipoAtualizado.data || tipoAtualizado);

          // Pré-selecionar clientes compatíveis
          const clientesCompatíveis = clientes.filter((cliente) =>
            verificarCompatibilidadeCliente(
              cliente,
              tipoAtualizado.data || tipoAtualizado,
            ),
          );
          const idsClientesCompatíveis = clientesCompatíveis.map((c) => c.id);

          setClientesSelecionados(idsClientesCompatíveis);
          setTodosSelecionados(
            idsClientesCompatíveis.length === clientes.length,
          );
          setResultadoCriacao(null);
          setModalSelecaoClientesAberto(true);
        }
      } else {
        const novoTipo = await tipoObrigacaoService.create(dados);
        mostrarSnackbar("Tipo de obrigação criado com sucesso!");

        // Fechar modal atual e abrir modal de seleção de clientes
        fecharModal();
        carregarTipos();

        // Se existem clientes ativos, abrir modal de seleção
        if (clientes.length > 0) {
          setTipoObrigacaoCriado(novoTipo.data || novoTipo);

          // Pré-selecionar clientes compatíveis
          const clientesCompatíveis = clientes.filter((cliente) =>
            verificarCompatibilidadeCliente(cliente, novoTipo.data || novoTipo),
          );
          const idsClientesCompatíveis = clientesCompatíveis.map((c) => c.id);

          setClientesSelecionados(idsClientesCompatíveis);
          setTodosSelecionados(
            idsClientesCompatíveis.length === clientes.length,
          );
          setResultadoCriacao(null);
          setModalSelecaoClientesAberto(true);
        }
      }
    } catch (error) {
      mostrarSnackbar(
        "Erro ao salvar tipo de obrigação: " + error.message,
        "error",
      );
    } finally {
      setSalvando(false);
    }
  };

  const confirmarExclusao = (tipo) => {
    setConfirmacaoExclusao({
      aberto: true,
      tipoId: tipo.id,
      tipoDescricao: tipo.descricao,
    });
  };

  const excluirTipo = async () => {
    if (excluindo) return; // Evita cliques duplos

    try {
      setExcluindo(true);
      await tipoObrigacaoService.delete(confirmacaoExclusao.tipoId);
      mostrarSnackbar("Tipo de obrigação excluído com sucesso!");
      carregarTipos();
    } catch (error) {
      mostrarSnackbar(
        "Erro ao excluir tipo de obrigação: " + error.message,
        "error",
      );
    } finally {
      setExcluindo(false);
      setConfirmacaoExclusao({
        aberto: false,
        tipoId: null,
        tipoDescricao: "",
      });
    }
  };

  // Função para abrir modal de obrigações padrão
  const abrirModalObrigacoesPadrao = async () => {
    try {
      setCarregandoTiposPadrao(true);
      const response = await tipoObrigacaoService.getDefault();
      setTiposPadrao(response.tipos_obrigacoes || []);
      setModalObrigacoesPadraoAberto(true);
    } catch (error) {
      mostrarSnackbar(
        "Erro ao carregar obrigações padrão: " + error.message,
        "error",
      );
    } finally {
      setCarregandoTiposPadrao(false);
    }
  };

  // Função para criar múltiplas obrigações
  const criarObrigacoesPadrao = async (tiposParaCriar) => {
    try {
      const response =
        await tipoObrigacaoService.createMultiple(tiposParaCriar);

      if (response.erros && response.erros.length > 0) {
        mostrarSnackbar(
          `${response.sucesso} obrigações criadas com sucesso. Avisos: ${response.erros.join(", ")}`,
          "warning",
        );
      } else {
        mostrarSnackbar(
          `${response.sucesso} obrigações criadas com sucesso!`,
          "success",
        );
      }

      setModalObrigacoesPadraoAberto(false);
      carregarTipos();
    } catch (error) {
      mostrarSnackbar(
        "Erro ao criar obrigações padrão: " + error.message,
        "error",
      );
    }
  };

  const formatarRecorrencia = (tipo) => {
    if (tipo.dia_recorrente && tipo.mes_recorrente) {
      return `Dia ${tipo.dia_recorrente} do mês ${tipo.mes_recorrente}`;
    } else if (tipo.dia_recorrente) {
      return `Todo dia ${tipo.dia_recorrente}`;
    } else if (tipo.mes_recorrente) {
      return `Todo mês ${tipo.mes_recorrente}`;
    }
    return "Não definido";
  };

  const formatarPrazoLegal = (tipo) => {
    if (tipo.dia_recorrente_real && tipo.mes_recorrente_real) {
      return `Dia ${tipo.dia_recorrente_real} do mês ${tipo.mes_recorrente_real}`;
    } else if (tipo.dia_recorrente_real) {
      return `Todo dia ${tipo.dia_recorrente_real}`;
    } else if (tipo.mes_recorrente_real) {
      return `Todo mês ${tipo.mes_recorrente_real}`;
    }
    return "Não definido";
  };

  const handleChangePage = (event, newPage) => {
    setPaginacao((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPaginacao((prev) => ({
      ...prev,
      limit: parseInt(event.target.value, 10),
      page: 0,
    }));
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 600, color: "#333" }}>
          Tipos de obrigações
        </Typography>
        <Box>
          <Button
            variant="outlined"
            startIcon={<FilterIcon />}
            onClick={() => setMostrarFiltros(!mostrarFiltros)}
            sx={{ mr: 2 }}
          >
            Filtros
          </Button>
          <Button
            variant="outlined"
            startIcon={
              carregandoTiposPadrao ? (
                <CircularProgress size={16} />
              ) : (
                <ContentCopyIcon />
              )
            }
            onClick={abrirModalObrigacoesPadrao}
            disabled={carregandoTiposPadrao}
            sx={{ mr: 2 }}
          >
            {carregandoTiposPadrao
              ? "Carregando..."
              : "Criar obrigações padrão"}
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => abrirModalTipo()}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
          >
            Novo tipo
          </Button>
        </Box>
      </Box>

      {/* Filtros */}
      {mostrarFiltros && (
        <Card
          sx={{
            mb: 3,
            p: 3,
            backgroundColor: "#f5f5f5",
            borderRadius: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{ mb: 2, color: "#333", fontWeight: 600 }}
          >
            Filtros
          </Typography>

          {/* ✅ SOLUÇÃO CSS PURA - Funciona em qualquer versão do Material-UI */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
              flexWrap: { xs: "wrap", md: "nowrap" }, // Mobile: quebra linha, Desktop: mesma linha
              alignItems: "center",
            }}
          >
            {/* Campo de Busca */}
            <Box
              sx={{
                flex: `0 1 ${TAMANHOS_FILTROS.busca}%`,
                minWidth: { xs: "100%", md: "200px" },
                maxWidth: { md: `${TAMANHOS_FILTROS.busca}%` },
              }}
            >
              <TextField
                fullWidth
                label="Buscar por descrição"
                placeholder="Ex: IRPJ, ICMS, ISS..."
                value={filtros.busca}
                onChange={(e) => handleFiltroChange("busca", e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                  },
                }}
              />
            </Box>

            {/* Filtro Simples Nacional */}
            <Box
              sx={{
                flex: `0 1 ${TAMANHOS_FILTROS.simples_nacional}%`,
                minWidth: { xs: "100%", md: "120px" },
                maxWidth: { md: `${TAMANHOS_FILTROS.simples_nacional}%` },
              }}
            >
              <FormControl fullWidth size="medium">
                <InputLabel>Simples nacional</InputLabel>
                <Select
                  value={filtros.simples_nacional}
                  label="Simples nacional"
                  onChange={(e) =>
                    handleFiltroChange("simples_nacional", e.target.value)
                  }
                  sx={{
                    backgroundColor: "white",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                    },
                  }}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="true">Sim</MenuItem>
                  <MenuItem value="false">Não</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Filtro Lucro Presumido */}
            <Box
              sx={{
                flex: `0 1 ${TAMANHOS_FILTROS.lucro_presumido}%`,
                minWidth: { xs: "100%", md: "120px" },
                maxWidth: { md: `${TAMANHOS_FILTROS.lucro_presumido}%` },
              }}
            >
              <FormControl fullWidth size="medium">
                <InputLabel>Lucro presumido</InputLabel>
                <Select
                  value={filtros.lucro_presumido}
                  label="Lucro presumido"
                  onChange={(e) =>
                    handleFiltroChange("lucro_presumido", e.target.value)
                  }
                  sx={{
                    backgroundColor: "white",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                    },
                  }}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="true">Sim</MenuItem>
                  <MenuItem value="false">Não</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Filtro Lucro Real */}
            <Box
              sx={{
                flex: `0 1 ${TAMANHOS_FILTROS.lucro_real}%`,
                minWidth: { xs: "100%", md: "120px" },
                maxWidth: { md: `${TAMANHOS_FILTROS.lucro_real}%` },
              }}
            >
              <FormControl fullWidth size="medium">
                <InputLabel>Lucro real</InputLabel>
                <Select
                  value={filtros.lucro_real}
                  label="Lucro real"
                  onChange={(e) =>
                    handleFiltroChange("lucro_real", e.target.value)
                  }
                  sx={{
                    backgroundColor: "white",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                    },
                  }}
                >
                  <MenuItem value="">Todos</MenuItem>
                  <MenuItem value="true">Sim</MenuItem>
                  <MenuItem value="false">Não</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Campo de Escritório - apenas para super admin */}
            {user?.is_super_admin && (
              <Box
                sx={{
                  flex: `0 1 ${TAMANHOS_FILTROS.escritorio}%`,
                  minWidth: { xs: "100%", md: "150px" },
                  maxWidth: { md: `${TAMANHOS_FILTROS.escritorio}%` },
                }}
              >
                <FormControl fullWidth size="medium">
                  <InputLabel>Escritório</InputLabel>
                  <Select
                    value={filtros.escritorio_id_filter}
                    label="Escritório"
                    onChange={(e) =>
                      handleFiltroChange("escritorio_id_filter", e.target.value)
                    }
                    sx={{
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                      },
                    }}
                  >
                    <MenuItem value="">Todos os escritórios</MenuItem>
                    {escritorios.map((escritorio) => (
                      <MenuItem key={escritorio.id} value={escritorio.id}>
                        {escritorio.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}
          </Box>

          {/* Botão para limpar filtros */}
          <Box sx={{ mt: 3 }}>
            <Button
              onClick={() => {
                setFiltros({
                  busca: "",
                  simples_nacional: "",
                  lucro_presumido: "",
                  lucro_real: "",
                  escritorio_id_filter: "",
                });
                setPaginacao((prev) => ({ ...prev, page: 0 }));
              }}
              variant="outlined"
              size="small"
            >
              Limpar filtros
            </Button>
          </Box>
        </Card>
      )}

      {/* Tabela */}
      <Card>
        <TableContainer component={Paper}>
          <Table sx={{ "& .MuiTableCell-root": { py: 1.5 } }}>
            {" "}
            {/* ✅ Reduz altura das linhas */}
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, py: 1.5 }}>
                  Descrição
                </TableCell>
                <TableCell sx={{ fontWeight: 600, py: 1.5 }}>
                  Recorrência
                </TableCell>
                <TableCell sx={{ fontWeight: 600, py: 1.5 }}>
                  Prazo legal
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, py: 1.5, textAlign: "center" }}
                >
                  Simples nacional
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, py: 1.5, textAlign: "center" }}
                >
                  Lucro presumido
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, py: 1.5, textAlign: "center" }}
                >
                  Lucro real
                </TableCell>
                <TableCell sx={{ fontWeight: 600, py: 1.5 }}>
                  Setor responsável
                </TableCell>
                {user?.is_super_admin && (
                  <TableCell sx={{ fontWeight: 600, py: 1.5 }}>
                    Escritório
                  </TableCell>
                )}
                <TableCell
                  sx={{ fontWeight: 600, textAlign: "center", py: 1.5 }}
                >
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={user?.is_super_admin ? 9 : 8}
                    sx={{ textAlign: "center", py: 2 }}
                  >
                    Carregando...
                  </TableCell>
                </TableRow>
              ) : tipos.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={user?.is_super_admin ? 9 : 8}
                    sx={{ textAlign: "center", py: 2 }}
                  >
                    Nenhum tipo de obrigação encontrado. Cadastre primeiro os
                    setores, pois os tipos de obrigações serão associados a
                    eles.
                  </TableCell>
                </TableRow>
              ) : (
                tipos.map((tipo) => (
                  <TableRow key={tipo.id} hover>
                    <TableCell sx={{ py: 1.5 }}>{tipo.descricao}</TableCell>
                    <TableCell sx={{ py: 1.5 }}>
                      {formatarRecorrencia(tipo)}
                    </TableCell>
                    <TableCell sx={{ py: 1.5 }}>
                      {formatarPrazoLegal(tipo)}
                    </TableCell>
                    <TableCell sx={{ py: 1.5, textAlign: "center" }}>
                      {tipo.simples_nacional ? (
                        <Chip
                          label="Sim"
                          size="small"
                          color="success"
                          sx={{ fontWeight: 600 }}
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell sx={{ py: 1.5, textAlign: "center" }}>
                      {tipo.lucro_presumido ? (
                        <Chip
                          label="Sim"
                          size="small"
                          color="success"
                          sx={{ fontWeight: 600 }}
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell sx={{ py: 1.5, textAlign: "center" }}>
                      {tipo.lucro_real ? (
                        <Chip
                          label="Sim"
                          size="small"
                          color="success"
                          sx={{ fontWeight: 600 }}
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell sx={{ py: 1.5 }}>
                      {tipo.setor?.descricao || "-"}
                    </TableCell>
                    {user?.is_super_admin && (
                      <TableCell sx={{ py: 1.5 }}>
                        {tipo.escritorio?.nome || "-"}
                      </TableCell>
                    )}
                    <TableCell sx={{ textAlign: "center", py: 1.5 }}>
                      <Tooltip title="Editar">
                        <IconButton
                          onClick={() => abrirModalTipo(tipo)}
                          color="info"
                          size="small"
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir">
                        <IconButton
                          onClick={() => confirmarExclusao(tipo)}
                          color="error"
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={paginacao.total}
          page={paginacao.page}
          onPageChange={handleChangePage}
          rowsPerPage={paginacao.limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          labelRowsPerPage="Linhas por página:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count}`
          }
        />
      </Card>

      {/* Modal de Criação/Edição */}
      <Dialog open={modalAberto} onClose={fecharModal} maxWidth="sm" fullWidth>
        <DialogTitle>
          {tipoEditando ? "Editar tipo de obrigação" : "Novo tipo de obrigação"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Descrição *"
            fullWidth
            variant="outlined"
            value={dadosTipo.descricao}
            onChange={(e) => handleInputChange("descricao", e.target.value)}
            placeholder="Ex: IRPJ, ICMS, ISS..."
            sx={{ mt: 2 }}
          />
          <TextField
            margin="dense"
            label="Dia recorrente *"
            type="number"
            fullWidth
            variant="outlined"
            value={dadosTipo.dia_recorrente}
            onChange={(e) =>
              handleInputChange("dia_recorrente", e.target.value)
            }
            placeholder="Ex: 15"
            inputProps={{ min: 1, max: 31 }}
            helperText="Dia do mês para gerar (1-31)"
            sx={{ mt: 2 }}
          />
          <TextField
            margin="dense"
            label="Mês recorrente (para obrigações anuais)"
            type="number"
            fullWidth
            variant="outlined"
            value={dadosTipo.mes_recorrente}
            onChange={(e) =>
              handleInputChange("mes_recorrente", e.target.value)
            }
            placeholder="Ex: 03"
            inputProps={{ min: 1, max: 12 }}
            helperText="Mês do ano (1-12) nas obrigações anuais"
            sx={{ mt: 2 }}
          />

          {/* Prazo Legal */}
          <Typography
            variant="subtitle1"
            sx={{ mt: 3, mb: 2, fontWeight: 600 }}
          >
            Prazo legal (vencimento real):
          </Typography>
          <TextField
            margin="dense"
            label="Dia recorrente real (opcional)"
            type="number"
            fullWidth
            variant="outlined"
            value={dadosTipo.dia_recorrente_real}
            onChange={(e) =>
              handleInputChange("dia_recorrente_real", e.target.value)
            }
            placeholder="Ex: 20"
            inputProps={{ min: 1, max: 31 }}
            helperText="Dia do mês do vencimento real (1-31)"
            sx={{ mt: 2 }}
          />
          <TextField
            margin="dense"
            label="Mês recorrente real (para obrigações anuais)"
            type="number"
            fullWidth
            variant="outlined"
            value={dadosTipo.mes_recorrente_real}
            onChange={(e) =>
              handleInputChange("mes_recorrente_real", e.target.value)
            }
            placeholder="Ex: 03"
            inputProps={{ min: 1, max: 12 }}
            helperText="Mês do ano do vencimento real (1-12) nas obrigações anuais"
            sx={{ mt: 2 }}
          />

          {/* Setor responsável */}
          {!loading && setores.length === 0 && (
            <Alert severity="error" sx={{ mt: 2 }}>
              Recomendamos criar os setores primeiro para poder atribuir setores
              ao novo tipo de obrigação.
            </Alert>
          )}
          <FormControl
            fullWidth
            margin="normal"
            variant="outlined"
            sx={{ mt: 2 }}
          >
            <InputLabel>Setor responsável</InputLabel>
            <Select
              value={dadosTipo.setor_id}
              onChange={(e) => handleInputChange("setor_id", e.target.value)}
              label="Setor responsável"
            >
              <MenuItem value="">
                <em>Nenhum setor</em>
              </MenuItem>
              {setores.map((setor) => (
                <MenuItem key={setor.id} value={setor.id}>
                  {setor.descricao}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Regimes tributários */}
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
              Regimes tributários que precisam pagar esta obrigação:
            </Typography>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dadosTipo.simples_nacional}
                  onChange={(e) =>
                    handleInputChange("simples_nacional", e.target.checked)
                  }
                />
              }
              label="Simples nacional"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={dadosTipo.lucro_presumido}
                  onChange={(e) =>
                    handleInputChange("lucro_presumido", e.target.checked)
                  }
                />
              }
              label="Lucro presumido"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={dadosTipo.lucro_real}
                  onChange={(e) =>
                    handleInputChange("lucro_real", e.target.checked)
                  }
                />
              }
              label="Lucro real"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={fecharModal} color="inherit">
            Cancelar
          </Button>
          <Button onClick={salvarTipo} variant="contained" disabled={salvando}>
            {salvando ? (
              <CircularProgress size={20} />
            ) : tipoEditando ? (
              "Atualizar"
            ) : (
              "Criar"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Confirmação de Exclusão */}
      <Dialog
        open={confirmacaoExclusao.aberto}
        onClose={() =>
          setConfirmacaoExclusao({
            aberto: false,
            tipoId: null,
            tipoDescricao: "",
          })
        }
      >
        <DialogTitle>Confirmar exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja excluir o tipo de obrigação "
            {confirmacaoExclusao.tipoDescricao}"?
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Esta ação não pode ser desfeita.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setConfirmacaoExclusao({
                aberto: false,
                tipoId: null,
                tipoDescricao: "",
              })
            }
            color="primary"
          >
            Cancelar
          </Button>
          <Button
            onClick={excluirTipo}
            color="error"
            variant="contained"
            disabled={excluindo}
          >
            {excluindo ? <CircularProgress size={20} /> : "Excluir"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de seleção de clientes para criar recorrências */}
      <Dialog
        open={modalSelecaoClientesAberto}
        onClose={fecharModalSelecaoClientes}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Criar recorrências para "{tipoObrigacaoCriado?.descricao}"
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Selecione os clientes que devem receber uma recorrência para este
            novo tipo de obrigação. Serão criadas automaticamente as
            recorrências e as primeiras obrigações para cada cliente
            selecionado. Clientes marcados como "Compatível" já vêm
            pré-selecionados e você pode desmarcar se necessário. Os
            "Incompatíveis" podem ser selecionados se necessário.
          </Typography>

          {clientes.length === 0 ? (
            <Alert severity="info">
              Não há clientes ativos disponíveis para criar recorrências.
            </Alert>
          ) : (
            <>
              {/* Controle para selecionar todos */}
              <Box
                sx={{
                  mb: 2,
                  p: 2,
                  backgroundColor: "#f5f5f5",
                  borderRadius: 1,
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={todosSelecionados}
                      indeterminate={
                        clientesSelecionados.length > 0 &&
                        clientesSelecionados.length < clientes.length
                      }
                      onChange={toggleTodosClientesSelecao}
                    />
                  }
                  label={
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      Selecionar todos os clientes ({clientes.length})
                    </Typography>
                  }
                />
              </Box>

              {/* Lista de clientes */}
              <Box
                sx={{
                  maxHeight: 400,
                  overflow: "auto",
                  border: 1,
                  borderColor: "divider",
                  borderRadius: 1,
                  backgroundColor: "background.paper",
                }}
              >
                {clientes.map((cliente) => {
                  const isCompatible = verificarCompatibilidadeCliente(
                    cliente,
                    tipoObrigacaoCriado,
                  );

                  return (
                    <Box
                      key={cliente.id}
                      sx={{
                        p: 2,
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        "&:last-child": { borderBottom: "none" },
                        "&:hover": { backgroundColor: "action.hover" },
                        backgroundColor: isCompatible ? "inherit" : "#fff3e0",
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={clientesSelecionados.includes(cliente.id)}
                            onChange={() => toggleClienteSelecao(cliente.id)}
                          />
                        }
                        label={
                          <Box>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Typography
                                variant="body1"
                                sx={{ fontWeight: 500 }}
                              >
                                {cliente.nome}
                              </Typography>
                              {isCompatible ? (
                                <Chip
                                  label="Compatível"
                                  size="small"
                                  color="success"
                                  variant="outlined"
                                  sx={{ fontSize: "0.75rem", height: "20px" }}
                                />
                              ) : (
                                <Chip
                                  label="Incompatível"
                                  size="small"
                                  color="warning"
                                  variant="outlined"
                                  sx={{ fontSize: "0.75rem", height: "20px" }}
                                />
                              )}
                            </Box>
                            {cliente.fantasia && (
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {cliente.fantasia}
                              </Typography>
                            )}
                            <Box sx={{ display: "flex", gap: 2, mt: 0.5 }}>
                              {cliente.cnpj && (
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  CNPJ: {cliente.cnpj}
                                </Typography>
                              )}
                              {cliente.regime_tributario && (
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  Regime:{" "}
                                  {cliente.regime_tributario ===
                                  "simples_nacional"
                                    ? "Simples nacional"
                                    : cliente.regime_tributario ===
                                        "lucro_presumido"
                                      ? "Lucro presumido"
                                      : cliente.regime_tributario ===
                                          "lucro_real"
                                        ? "Lucro real"
                                        : cliente.regime_tributario}
                                </Typography>
                              )}
                            </Box>
                            {!isCompatible && (
                              <Typography
                                variant="caption"
                                color="warning.main"
                              >
                                Regime tributário do cliente não é compatível
                                com este tipo de obrigação
                              </Typography>
                            )}
                          </Box>
                        }
                        sx={{ width: "100%", margin: 0 }}
                      />
                    </Box>
                  );
                })}
              </Box>

              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                {clientesSelecionados.length} de {clientes.length} clientes
                selecionados
              </Typography>

              {/* Resultado da criação */}
              {resultadoCriacao && (
                <Box sx={{ mt: 3 }}>
                  <Alert
                    severity={
                      resultadoCriacao.total_recorrencias_criadas > 0
                        ? "success"
                        : "warning"
                    }
                    sx={{ mb: 2 }}
                  >
                    <Typography variant="h6">Resultado da criação:</Typography>
                    <Typography>
                      {resultadoCriacao.total_recorrencias_criadas}{" "}
                      recorrência(s) criada(s)
                      {resultadoCriacao.total_obrigacoes_criadas > 0 &&
                        ` e ${resultadoCriacao.total_obrigacoes_criadas} obrigação(ões) criada(s)`}{" "}
                      para {resultadoCriacao.clientes_processados} cliente(s).
                    </Typography>
                  </Alert>

                  {/* Detalhes por cliente */}
                  <Box sx={{ maxHeight: 200, overflow: "auto" }}>
                    {resultadoCriacao.detalhes_por_cliente.map(
                      (detalhe, index) => (
                        <Box
                          key={index}
                          sx={{
                            mb: 1,
                            p: 1,
                            backgroundColor: detalhe.sucesso
                              ? "#f0f8f0"
                              : "#fff3f3",
                            borderRadius: 1,
                          }}
                        >
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {detalhe.nome}:
                          </Typography>
                          {detalhe.sucesso ? (
                            <Box>
                              <Typography
                                variant="caption"
                                color="success.main"
                              >
                                ✓ Recorrência e obrigação criadas com sucesso
                              </Typography>
                              {detalhe.compativel === false && (
                                <Typography
                                  variant="caption"
                                  color="warning.main"
                                  display="block"
                                >
                                  ⚠ Cliente incompatível com o regime
                                  tributário
                                </Typography>
                              )}
                            </Box>
                          ) : (
                            <Typography variant="caption" color="error">
                              ✗ {detalhe.erro}
                            </Typography>
                          )}
                        </Box>
                      ),
                    )}
                  </Box>
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={fecharModalSelecaoClientes}>
            {resultadoCriacao ? "Fechar" : "Pular"}
          </Button>
          {!resultadoCriacao && clientes.length > 0 && (
            <Button
              onClick={criarRecorrenciasLote}
              variant="contained"
              disabled={
                clientesSelecionados.length === 0 || criandoRecorrencias
              }
              startIcon={
                criandoRecorrencias ? <CircularProgress size={20} /> : null
              }
            >
              {criandoRecorrencias ? "Criando..." : "Criar recorrências"}
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {/* Snackbar para notificações */}
      <Snackbar
        open={snackbar.aberto}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, aberto: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, aberto: false })}
          severity={snackbar.tipo}
          sx={{ width: "100%" }}
        >
          {snackbar.mensagem}
        </Alert>
      </Snackbar>

      {/* Modal de obrigações padrão */}
      <ObrigacoesPadraoModal
        open={modalObrigacoesPadraoAberto}
        onClose={() => setModalObrigacoesPadraoAberto(false)}
        tiposPadrao={tiposPadrao}
        setores={setores}
        onSubmit={criarObrigacoesPadrao}
        loading={false}
      />
    </Box>
  );
};

export default Impostos;
